module.exports = __webpack_public_path__ + "static/media/home-service-slider-4.6a12a935.jpg";